import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { messageId: String, prompt: String, default: String }

  async save() {
    const title = prompt(this.promptValue, this.defaultValue)
    if (!title) return

    const response = await fetch("/saved_readings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({
        message_id:   this.messageIdValue,
        title:        title,
        reading_type: "conversation"
      })
    })

    if (response.ok) {
      this.element.textContent = "♥"
      this.element.style.color = "var(--mc-secondary)"
    }
  }
}
